"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

var _DefaultButton = _interopRequireDefault(require("./DefaultButton"));

var _typography = require("../typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TertiaryButton = (0, _styledComponents.default)(_DefaultButton.default).withConfig({
  displayName: "TertiaryButton",
  componentId: "lhw6zv-0"
})(["display:inline-block;text-align:center;font:inherit;fill:", ";color:", ";border:thin solid transparent;background:", ";padding:8px;", " &:focus,&:active{border:thin dashed ", ";}&:hover,&:focus{color:", ";background:", ";", ";text-decoration:underline;", ",svg{color:", ";}}&[aria-disabled='true']{color:", ";opacity:0.6;}"], (0, _helpers.color)('white'), (0, _helpers.color)('accent-3'), (0, _helpers.color)('white'), function (p) {
  return p.hasText && "padding: 8px 20px;";
}, (0, _helpers.color)('accent-3'), (0, _helpers.color)('accent-3'), (0, _helpers.color)('white'), function (p) {
  return p.hasText && "box-shadow: none";
}, _typography.Body, (0, _helpers.color)('accent-3'), (0, _helpers.color)('accent-3'));
var _default = TertiaryButton;
exports.default = _default;